import * as tslib_1 from "tslib";
import { composeStore, lazyDiscardCompose, lazyLoadDraftToCompose } from 'owa-mail-compose-store';
import { lazyNewMessage } from 'owa-mail-message-actions';
import selectFolderWithFallback from '../orchestrators/selectFolderWithFallback';
export function mailComposeNavigationRouteHandler(parameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectFolderWithFallback(parameters.folderId);
                    if (!parameters.draftId) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyLoadDraftToCompose.importAndExecute(parameters.draftId)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, lazyNewMessage.importAndExecute('Route')];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function mailComposeCleanupRouteHandler() {
    if (composeStore.defaultViewState) {
        return lazyDiscardCompose.importAndExecute(composeStore.defaultViewState).then(function () { return false; }, // Confirm ('Discard draft') means we should not block navigation
        function () { return true; }); // Cancel ('Dont' discard') means we should block navigation
    }
    else {
        return false;
    }
}
//# sourceMappingURL=mailComposeRouteHandler.js.map